var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.set_type == 'jlt')?_c('jltexam'):_vm._e(),(_vm.set_type != 'jlt')?_c('ncexam'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }